import React, { useState } from 'react';
import axios from 'axios';
import { Save, X, Upload } from 'lucide-react';

const EditProduct = ({ product, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: product.name || '',
    category: product.category || '',
    price: product.price || '',
    originalPrice: product.originalPrice || '',
    stock: product.stock || '',
    shortDescription: product.shortDescription || '',
    fullDescription: product.fullDescription || '',
    image: product.image || '',
    isActive: product.isActive !== undefined ? product.isActive : true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const categories = [
    'Indoor Plants', 'Outdoor Plants', 'Flowering Plants', 'Succulents', 
    'Cacti', 'Air Purifying Plants', 'Herbs', 'Ferns', 'Fruit Plants'
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      await axios.put(`/api/products/${product._id}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error('Failed to update product', err);
      setError(err.response?.data?.message || 'Failed to update product');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-4 shadow-sm p-4">
      <form onSubmit={handleSubmit}>
        {error && (
          <div className="alert alert-danger mb-4" role="alert">
            {error}
          </div>
        )}

        <div className="row g-4">
          <div className="col-md-6">
            <label className="form-label fw-semibold">Product Name *</label>
            <input
              type="text"
              name="name"
              className="form-control rounded-pill px-3 py-2"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6">
            <label className="form-label fw-semibold">Category *</label>
            <select
              name="category"
              className="form-select rounded-pill px-3 py-2"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">Select Category</option>
              {categories.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Price (₹) *</label>
            <input
              type="number"
              name="price"
              className="form-control rounded-pill px-3 py-2"
              value={formData.price}
              onChange={handleChange}
              required
              min="0"
              step="0.01"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Original Price (₹)</label>
            <input
              type="number"
              name="originalPrice"
              className="form-control rounded-pill px-3 py-2"
              value={formData.originalPrice}
              onChange={handleChange}
              min="0"
              step="0.01"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Stock Quantity *</label>
            <input
              type="number"
              name="stock"
              className="form-control rounded-pill px-3 py-2"
              value={formData.stock}
              onChange={handleChange}
              required
              min="0"
            />
          </div>

          <div className="col-12">
            <label className="form-label fw-semibold">Short Description *</label>
            <textarea
              name="shortDescription"
              className="form-control rounded-3 px-3 py-2"
              rows="2"
              value={formData.shortDescription}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12">
            <label className="form-label fw-semibold">Full Description</label>
            <textarea
              name="fullDescription"
              className="form-control rounded-3 px-3 py-2"
              rows="4"
              value={formData.fullDescription}
              onChange={handleChange}
            />
          </div>

          <div className="col-12">
            <label className="form-label fw-semibold">Product Image URL</label>
            <input
              type="text"
              name="image"
              className="form-control rounded-pill px-3 py-2"
              value={formData.image}
              onChange={handleChange}
              placeholder="https://example.com/image.jpg"
            />
            {formData.image && (
              <div className="mt-2">
                <img src={formData.image} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px' }} />
              </div>
            )}
          </div>

          <div className="col-12">
            <div className="form-check">
              <input
                type="checkbox"
                name="isActive"
                className="form-check-input"
                checked={formData.isActive}
                onChange={handleChange}
              />
              <label className="form-check-label fw-semibold">
                Product Active (visible to customers)
              </label>
            </div>
          </div>

          <div className="col-12 d-flex gap-3 pt-3">
            <button
              type="submit"
              className="btn btn-main rounded-pill px-5 py-2 fw-semibold d-flex align-items-center gap-2"
              disabled={loading}
            >
              {loading ? 'Saving...' : <><Save size={18} /> Save Changes</>}
            </button>
            <button
              type="button"
              onClick={onSuccess}
              className="btn btn-light rounded-pill px-5 py-2 fw-semibold d-flex align-items-center gap-2"
            >
              <X size={18} /> Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditProduct;